import { Observable, map, of, switchMap } from 'rxjs';

import { protocolsApi, ratingsApi } from 'api/modules';
import {
  MarketBadDebtRatingInfo,
  NetworkSlug,
  ProductSlug,
  VersionSlug,
  isMarketBadDebtRating,
} from 'domain/types';
import { getMarketName } from 'domain/utils';

export function getMarketBadDebtRatingInfo({
  productSlug,
  versionSlug,
  network,
  marketId,
}: {
  productSlug: ProductSlug;
  versionSlug: VersionSlug;
  network: NetworkSlug;
  marketId: string;
}): Observable<MarketBadDebtRatingInfo | null> {
  return ratingsApi.getMarketRatings$({ productSlug, versionSlug, marketId, network }).pipe(
    switchMap(ratings => {
      const rating = ratings.find(isMarketBadDebtRating);

      if (!rating) return of(null);

      return protocolsApi.getLendingInfo$(true, { network, versionSlug, productSlug }).pipe(
        map(
          (protocolInfo): MarketBadDebtRatingInfo => ({
            rating,
            transcription: {
              marketName: getMarketName(protocolInfo, marketId),
            },
          }),
        ),
      );
    }),
  );
}
